export default {
  fullStory: {
    orgId: 'WCTD6'
  }
}